import React from 'react';
import { Phone, MapPin, AlertCircle } from 'lucide-react';

const FinalCTA = () => {
  return (
    <section className="py-20 px-4 bg-gradient-to-br from-slate-900 via-slate-950 to-red-950/30 relative overflow-hidden">
      {/* Background effect */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-red-600 rounded-full blur-[120px] animate-pulse"></div>
      </div>
      
      <div className="max-w-5xl mx-auto relative z-10">
        <div className="bg-gradient-to-br from-slate-800/90 to-slate-900/90 backdrop-blur-xl p-10 md:p-16 rounded-3xl border-2 border-red-600/50 shadow-2xl text-center">
          <div className="flex justify-center mb-6">
            <AlertCircle className="h-16 w-16 text-red-600 animate-pulse" />
          </div>
          
          <h2 className="text-4xl md:text-5xl font-black text-white mb-6">
            Votre véhicule présente une panne ?
          </h2>
          
          <p className="text-xl md:text-2xl text-gray-300 mb-4 leading-relaxed">
            <strong className="text-white">Voyant moteur</strong>, problème électrique, défaut électronique, <strong className="text-white">perte de puissance</strong> ou problème de communication avec un calculateur ?
          </p>
          
          <p className="text-2xl text-red-600 font-bold mb-10">
            Contactez JC Performance-57 à Creutzwald pour prendre rendez-vous.
          </p>
          
          <div className="space-y-6">
            {/* Téléphone */}
            <a 
              href="tel:0749995728"
              className="inline-flex items-center justify-center space-x-4 bg-red-600 hover:bg-red-700 text-white font-bold px-10 py-6 rounded-2xl transition-all transform hover:scale-105 text-2xl shadow-lg w-full md:w-auto"
            >
              <Phone className="h-8 w-8" />
              <span>07 49 99 57 28</span>
            </a>
            
            {/* Adresse */}
            <div className="flex items-center justify-center space-x-4 text-gray-300 text-xl">
              <MapPin className="h-6 w-6 text-red-600" />
              <span><strong className="text-white">14 rue Saint-Malo</strong> – 57150 Creutzwald</span>
            </div>
          </div>
          
          <div className="mt-10 pt-10 border-t border-slate-700">
            <p className="text-gray-400 text-lg">
              <strong className="text-white">Intervention sur particuliers et professionnels</strong><br />
              Diagnostic • Recherche de panne • Électricité automobile • Reprogrammation moteur
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
